import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { addData } from '../../helpers/fackBackend_Helper';

function* getMsisdnPoolResponse({ payload: { data } }) {
    try {
        const response = yield call(addData, '/getMsisdnPoolData', data);
        if (response?.response?.Status) {
            yield put(actions.getMsisdnPoolSuccess(response?.response?.Data));
        } else {
            yield put(actions.getMsisdnPoolFailed(response?.response?.Message));
        }
    } catch (error) {
        yield put(actions.getMsisdnPoolFailed(error));
    }
}

function* getShortCodeResultResponse({ payload: { data } }) {
    try {
        const response = yield call(addData, '/shortCode', data);
        if (response.response.Status) {
            yield put(actions.getShortCodeDataSuccess(response.response.Data));
        } else {
            yield put(actions.getShortCodeDataFailed(response.response.Message));
        }
    } catch (error) {
        yield put(actions.getShortCodeDataFailed(error));
    }
}


function* removeMsisdnPoolResponse({ payload: { data, searchData } }) {
    try {
        const response = yield call(addData, '/removeMsisdnStatus', data);
        if (response.Status) {
            yield put(actions.removeMsisdnFromPoolSuccess(response.Message));
            yield put(actions.getMsisdnPool(searchData));
        } else {
            yield put(actions.removeMsisdnFromPoolFailed(response.Message));
        }
    } catch (error) {
        yield put(actions.removeMsisdnFromPoolFailed(error.message));
    }
}

export default function* rootSaga() {
    yield all([takeEvery(actions.GET_MSISDN_POOL_DATA, getMsisdnPoolResponse)]);
    yield all([takeEvery(actions.GET_SHORT_CODE_DATA, getShortCodeResultResponse)]);
    yield all([takeEvery(actions.REMOVE_MSISDN_FROM_POOL, removeMsisdnPoolResponse)]);
}
